import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    DELETE_ROLE,
    deleteRoleFail,
    deleteRoleSuccess
} from '../action/deleteRoleAction'

// api 
import deleteRoleApi from '../api/deleteRoleApi'

export function* deleteRoleSaga(action) {
    try {
        const response = yield call(() => deleteRoleApi(action.params))
        if (response.data.status === 1) {
            yield put(deleteRoleSuccess(response, action))
        } else {
            yield put(deleteRoleFail(response, action))
        }
    }
    catch (e) {
        yield put(deleteRoleFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(DELETE_ROLE, deleteRoleSaga)
}